export default "__VITE_ASSET__xCz134BT__"